(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-before-after-section"] && !Shopify.designMode) return;
  try {
    
const sliderHandle = document.querySelector("#sliderHandle");
const sliderLine = document.querySelector(".slider-line");
const beforeImage = document.querySelector(".before-image");
const afterImage = document.querySelector(".after-image");
const sliderContainer = document.querySelector(".slider-container");

let isDragging = false;

// Function to initialize the slider at the center position
const initializeSlider = () => {
  const containerWidth = sliderContainer.offsetWidth;

  // Set slider handle and line at center with a transition for initialization
  sliderHandle.style.transition = "left 0.3s ease";
  sliderLine.style.transition = "left 0.3s ease";

  sliderHandle.style.left = "50%";
  sliderLine.style.left = "50%";

  // Set both images' clip-path to 50% (center)
  beforeImage.style.clipPath = `inset(0 50% 0 0)`;
  afterImage.style.clipPath = `inset(0 0 0 50%)`;
};

// Function to move the slider based on user interaction
const moveSlider = (clientX) => {
  const containerRect = sliderContainer.getBoundingClientRect();
  let offsetX = clientX - containerRect.left;

  // Limit the slider movement within the full container width (0% to 100%)
  if (offsetX < 0) offsetX = 0; // Prevent overflow on the left
  if (offsetX > containerRect.width) offsetX = containerRect.width; // Prevent overflow on the right

  const percentage = Math.round((offsetX / containerRect.width) * 100);

  // Update the slider handle position and image clipping
  sliderHandle.style.left = `${percentage}%`;
  sliderLine.style.left = `${percentage}%`;

  // Adjust the clip-path for both images
  beforeImage.style.clipPath = `inset(0 ${100 - percentage}% 0 0)`;
  afterImage.style.clipPath = `inset(0 0 0 ${percentage}%)`;
};

// Add event listeners for both the handle and the line (including the SVG)
const startDragging = () => {
  isDragging = true;

  // Remove transitions while dragging for instant feedback
  sliderHandle.style.transition = "none";
  sliderLine.style.transition = "none";
};

const stopDragging = () => {
  isDragging = false;

  // Reapply transitions after dragging ends
  sliderHandle.style.transition = "left 0.3s ease";
  sliderLine.style.transition = "left 0.3s ease";
};

sliderHandle.addEventListener("mousedown", startDragging);
sliderLine.addEventListener("mousedown", startDragging); // Make SVG and line draggable

window.addEventListener("mousemove", (event) => {
  if (isDragging) {
    moveSlider(event.clientX);
  }
});

window.addEventListener("mouseup", stopDragging);

// For touch events on mobile
sliderHandle.addEventListener("touchstart", startDragging);
sliderLine.addEventListener("touchstart", startDragging); // Make SVG and line draggable

window.addEventListener("touchmove", (event) => {
  if (isDragging) {
    moveSlider(event.touches[0].clientX);
  }
});

window.addEventListener("touchend", stopDragging);

// Initialize the slider on page load
window.addEventListener("load", initializeSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
